import apolloClient from 'store/apolloClient';
import intersection from 'lodash/intersection';

import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { getCurrentLanguage } from 'modules/language/selectors/language';

import createAction from './';
import { knownErrors } from './otpForm';
import { SEND_OTP_CODE } from './sendOtpCode';
import { handleCommonErrors } from './commonErrors';
import { TOS_ALREADY_APPROVED } from './termsOfService';
import * as services from '../services/acceptTermsAndConditions';

export const SET_TERMS_AND_CONDITIONS_ACCEPTED = createAsyncAction(createAction('SET_TERMS_AND_CONDITIONS_ACCEPTED'));

export const acceptTermsAndConditions = () => (dispatch, getState) => {
  dispatch({ type: SET_TERMS_AND_CONDITIONS_ACCEPTED.pending });

  const state = getState();

  const { policyId, email, phoneNumber, tosToken, secondaryLoginData } = state.auth.userInfo;
  const orgId = Number(state.auth.organizations.selectedOrganizationToken);
  const locale = getCurrentLanguage();
  const userData = policyId
    ? { externalId: policyId, phoneNumber, email }
    : secondaryLoginData;

  const apiCallParams = {
    mutation: services.ACCEPT_TERMS_AND_CONDITIONS,
    variables: {
      ...userData,
      orgId,
      token: tosToken,
      locale,
    },
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(({
        data: {
          acceptTermsAndConditions: {
            token,
            refreshToken,
            jwt,
            tosRequired,
            session: {
              user,
            },
          },
        },
      }) => {
      dispatch({
        type: SEND_OTP_CODE.success,
        payload: {
          jwtToken: jwt,
          tosToken: token,
          tosRequired,
          refreshToken,
          user,
        },
      });

      dispatch({ type: SET_TERMS_AND_CONDITIONS_ACCEPTED.success });

      return dispatch({ type: TOS_ALREADY_APPROVED });
    })
    .catch((err) => {
      dispatch(errorAction(SEND_OTP_CODE.failure, err));
      const { errorCodes } = getState().auth.otpForm;
      const handledErrorCodes = intersection(errorCodes, knownErrors);
      if (handledErrorCodes.length === 0) dispatch(handleCommonErrors(errorCodes));
    });
};
